<template>
  <aside
    class="relative z-50 hidden lg:flex w-[300px] h-full bg-gradient-to-b from-[#1D1D1D] via-[#1D1D1D] to-[#313B44]"
  >
    <div
      class="w-full h-full p-5 flex flex-col space-y-6 overflow-y-auto max-h-screen custom-scrollbar"
    >
      <div class="flex justify-center">
        <img src="@/assets/sidebar-logo.png" alt="Logo" class="h-10" />
      </div>

      <nav class="flex flex-col space-y-4">
        <SidebarItem :icon="HomeIcon" label="Home" path="/" />

        <SidebarItem
          :icon="Crown2Icon"
          label="King of the Hill"
          path="/king-of-the-hill"
        />
        <SidebarItem :icon="GameConsoleIcon" label="Bounties" path="/bounties" />

        <!-- <SidebarItem
          :icon="DollarSquareIcon"
          label="Monthly Bonus"
          path="/monthly-bonus"
        /> -->

        <SidebarItem :icon="FlagIcon" label="Milestones" path="/milestones" />

        <SidebarItem
          :icon="ChartIcon"
          label="Leaderboards"
          :badge="leaderboardBadge"
          :dropdown="['Metaspins', 'Empire Drop', 'Dailyspins', 'Rain.GG', 'Chicken.GG']"
          path="/leaderboards"
        />

        <SidebarItem :icon="CartIcon" label="Store" path="/store" />

        <SidebarItem :icon="GiftIcon" label="Giveaways" badge="FREE" path="/giveaways" />

        <SidebarItem :icon="CrownIcon" label="VIP" badge="PRO" path="/vip" />
      </nav>

      <!-- Divider Line -->
      <div class="border-t border-gray-600"></div>

      <div class="flex flex-col justify-center items-center space-y-3">
        <img
          @click="openLink('dailyspins')"
          src="@/assets/sidebar-playon1.png"
          alt="Daily Spins"
          class="h-[60px] object-contain hover:cursor-pointer"
        />
        <img
          @click="openLink('metaspins')"
          src="@/assets/sidebar-playon2.png"
          alt="Metaspins"
          class="h-[50px] object-contain hover:cursor-pointer"
        />
        <img
          @click="openLink('empiredrop')"
          src="@/assets/sidebar-playon3.png"
          alt="EmpireDrop"
          class="h-[52px] object-contain hover:cursor-pointer"
        />
        <img
          @click="openLink('raingg')"
          src="@/assets/sidebar-playon4.png"
          alt="RainGG"
          class="h-[54px] w-[150px] object-contain hover:cursor-pointer"
        />
        <img
          @click="openLink('chickengg')"
          src="@/assets/sidebar-playon5.png"
          alt="RainGG"
          class="h-[50px] w-[174px] object-contain hover:cursor-pointer"
        />
      </div>
    </div>
  </aside>
</template>

<script setup>
import SidebarItem from "./SidebarItem.vue";
import HomeIcon from "@/assets/home.svg";
import FlagIcon from "@/assets/flag.svg";
import Crown2Icon from "@/assets/crown-2.svg";
import ChartIcon from "@/assets/chart.svg";
import CartIcon from "@/assets/shopping-cart.svg";
import GiftIcon from "@/assets/gift.svg";
import CrownIcon from "@/assets/crown.svg";
import GameConsoleIcon from "@/assets/game-console.svg";
// import DollarSquareIcon from "@/assets/dollar-square.svg";
</script>

<script>
export default {
  data() {
    const getTotalPrizePoolBadge = () => {
      try {
        const dailyspins = JSON.parse(
          process.env.VUE_APP_DAILYSPINS_LEADERBOARD_CURRENT_PRIZES || "[]"
        );
        const empiredrop = JSON.parse(
          process.env.VUE_APP_EMPIREDROP_LEADERBOARD_CURRENT_PRIZES || "[]"
        );
        const metaspins = JSON.parse(
          process.env.VUE_APP_METASPINS_LEADERBOARD_CURRENT_PRIZES || "[]"
        );
        const raingg = JSON.parse(
          process.env.VUE_APP_RAINGG_LEADERBOARD_CURRENT_PRIZES || "[]"
        );

        const total = [...dailyspins, ...empiredrop, ...metaspins, ...raingg].reduce(
          (acc, val) => acc + val,
          0
        );
        return total >= 1000 ? `${Math.floor(total / 1000)}k` : `${total}`;
      } catch (e) {
        return "";
      }
    };

    return {
      leaderboardBadge: getTotalPrizePoolBadge(),
    };
  },
  methods: {
    openLink(site) {
      const urls = {
        dailyspins: "https://dailyspins.com/?ref=BALLYBOY",
        metaspins: "https://metamedialinks.com/e36249d00",
        empiredrop: "https://empiredrop.com/?r=Ballyboy",
        raingg: "https://rain.gg/r/Ballyboy ",
        chickengg: "https://chicken.gg/r/Ballyboy",
      };

      const url = urls[site];
      if (url) window.open(url, "_blank");
    },
  },
};
</script>